export default {
  path: '/my-ticket',
  meta: {
    title: '我的号码',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/my-ticket`),
}



// WEBPACK FOOTER //
// ./src/views/Myticket/router.js